import { WhiteLabelVisibilitySettingNames } from './types';

export const DEFAULT_WHITE_LABEL_ITEM_VISIBILITIES: Record<
  WhiteLabelVisibilitySettingNames,
  boolean
> = {
  isSearchVisible: true,
  isCourseNavigationVisible: true,
  isLanguageSelectorVisible: true,
  isAccountMenuProfileVisible: true,
  isAccountMenuInformationVisible: true,
  isAccountMenuChatHistoryVisible: true,
};
